import { render, staticRenderFns } from "./MedicationList.vue?vue&type=template&id=77cb91ee&scoped=true"
import script from "./MedicationList.vue?vue&type=script&lang=js"
export * from "./MedicationList.vue?vue&type=script&lang=js"
import style0 from "./MedicationList.vue?vue&type=style&index=0&id=77cb91ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb91ee",
  null
  
)

export default component.exports